export class ClientLogo {
    logoFilePath: string;
}